import type { SVGProps } from 'react';
const SvgKnowledgeBaseSidebar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="currentColor"
      fillOpacity={0.88}
      d="M13.714 0H2.285a.57.57 0 0 0-.571.571V15.43a.57.57 0 0 0 .571.571h11.429a.57.57 0 0 0 .571-.571V.57A.57.57 0 0 0 13.714 0M9.07 1.286h1.714v3.748l-.83-.605-.884.632zM13 14.714H3V1.286h5v5.302a.3.3 0 0 0 .053.166.284.284 0 0 0 .398.066l1.497-1.07L11.4 6.81a.287.287 0 0 0 .454-.23V1.286h1.143v13.428z"
    />
  </svg>
);
export default SvgKnowledgeBaseSidebar;
